<template>
  <div class="healthcheck-container">
    <div>
      <div class="row">
        <label
          id="view-closing-date-label"
          class="label-bold"
        >
          {{ $t('tender.tenderCloseAt') }}:
        </label>
        <div
          id="view-closing-date-value"
          class="text"
        >
          {{ showClosingDate() }}
        </div>
      </div>
      <div
        v-show="firstIssuedDate"
        class="row"
      >
        <label
          id="view-issued-label"
          class="label-bold"
        >
          {{ $t('tender.firstIssuedOn') }}:&nbsp;
        </label>
        <div
          id="view-issued-date-value"
          class="text"
        >
          {{ firstIssuedDate }}
        </div>
      </div>
      <div
        v-show="lastIssuedDate"
        class="row"
      >
        <label
          id="view-issued-label"
          class="label-bold"
        >
          {{ $t('tender.lastIssuedOn') }}:&nbsp;
        </label>
        <div
          id="view-issued-date-value"
          class="text"
        >
          {{ lastIssuedDate }}
        </div>
      </div>
      <div v-if="status === tenderStatus.ISSUED">
        <label
          id="view-days-left-label"
          class="days-left"
        >
          <span>{{ timeLeft }}</span>
        </label>
      </div>
      <div v-if="status === tenderStatus.READY">
        <label class="ready-for-review">
          {{ $t('tender.readyForReview') }}
        </label>
      </div>
    </div>

    <div class="onsite-visit">
      <div>
        <input
          id="view-closing-date-onsite-visit-required"
          v-model="general.onsiteVisitRequired"
          type="checkbox"
          disabled
        >
        <label
          id="view-closing-date-onsite-visit-required-label"
          class="text"
        >
          {{ $t('tender.general.onsiteVisitRequired') }}
        </label>
      </div>
      <div v-if="general.onsiteVisitRequired">
        <div>
          <label
            id="view-closing-date-onsite-location-label"
            class="label-bold"
          >
            {{ $t('tender.general.onSiteLocation') }}
          </label>
          <label
            id="view-closing-date-onsite-location-value"
            class="text onsite-contact"
          >
            {{ general.onsiteLocation }}
          </label>
        </div>
        <div>
          <label
            id="view-closing-date-onsite-contact-label"
            class="label-bold"
          >
            {{ $t('tender.general.onSiteContact') }}
          </label>
          <label
            id="view-closing-date-onsite-contact-name"
            class="text"
          >
            {{ onsiteContact.name }}
          </label>
          <label
            id="view-closing-date-onsite-contact-email"
            class="text"
          >
            {{ onsiteContact.email }}
          </label>
          <label
            id="view-closing-date-onsite-contact-phone"
            class="text"
          >
            {{ onsiteContact.phone }}
          </label>
        </div>
      </div>
    </div>
    <VendorBidStatusTable />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import dateUtil from '@/utils/dateUtil'
import { tenderStatus } from '@/utils/locale'
import VendorBidStatusTable from '@/modules/tenders/view/VendorBidStatusTable'

export default {
  name: 'ClosingDateView',
  components: {
    VendorBidStatusTable,
  },
  data () {
    return {
      deep,
    }
  },
  computed: {
    ...mapGetters('tenders', ['currentTender']),

    tenderStatus () {
      return tenderStatus
    },

    general () {
      return this.currentTender.general || {}
    },

    status () {
      return this.general.status
    },

    selectedClosingDate () {
      const closingDate = dateUtil.toMoment(this.general.closingDate)
      return dateUtil.parseClosingTime(closingDate)
    },

    timeLeft () {
      const closingDate = dateUtil.toMoment(this.general.closingDate)
      const today = dateUtil.toMoment(new Date())
      if (Number(closingDate.diff(today, 'days')) >= 1) {
        return `${closingDate.diff(today, 'days')} ${this.$t('tender.daysLeft')}`
      } else {
        return `${closingDate.diff(today, 'hours')} ${this.$t('tender.hoursLeft')}`
      }
    },

    onsiteContact () {
      return this.general.onsiteContact || {}
    },

    firstIssuedVersion () {
      return deep(this.currentTender, 'firstIssuedVersion.data')
    },

    lastIssuedDate () {
      return this.general.version && this.general.issuedDate ? dateUtil.formatDate(this.general.issuedDate, 'MMM dd') : null
    },

    firstIssuedDate () {
      const firstIssuedDate = this.firstIssuedVersion ? this.firstIssuedVersion.issuedDate : this.general.issuedDate
      return firstIssuedDate ? dateUtil.formatDate(firstIssuedDate, 'MMM dd') : null
    },
  },
  methods: {
    showClosingDate () {
      return this.selectedClosingDate ? `${this.selectedClosingDate[0]} ${this.selectedClosingDate[1]}` : '--'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/table';
$healthcheck-font-color: #0C3A58;
.healthcheck-container {
  #view-closing-date-label {
    margin-right: 10px;
  }
  .row {
    .label-bold, .text {
      line-height: 1.8;
      color: $healthcheck-font-color;
    }
  }
  .onsite-visit label{
    line-height: 1.8;
    font-weight: normal;
    color: $healthcheck-font-color;
  }
}
.tender-healthcheck-label {
  height: 22px;
  font-family: Georgia;
  font-size: 20px;
  text-align: left;
  color: $healthcheck-font-color;
}
.vendor-status-list {
  color: $healthcheck-font-color;
}
label {
  margin: 0;
}
.label-bold {
  margin: 0 0;
  font-weight: bold;
}

.days-left {
  font-size: 20px;
  font-weight: normal;
  text-align: left;
  vertical-align: middle;
  color: #d50000;
  span {
    font-size: 23px;
  }
}

.ready-for-review {
  font-family: Georgia;
  font-size: 20px;
  text-align: left;
  vertical-align: middle;
  color: #d50000;
  span {
    font-size: 23px;
  }
}

.onsite-contact {
  margin-bottom: 10px;
}
.vendor-name {
  width: 50%;
  min-width: 350px;
  word-wrap: break-word;
}
.visit-date {
  min-height: 40px;
  word-wrap: break-word;
  display: table-cell;
}
.vendor-status {
  width: 20%;
  min-width: 100px;
  span{
    display: inline-block;
  }
}

#view-closing-date-onsite-visit-required {
  vertical-align: middle;
}

.status-summary {
  text-align: right;
  label {
    display: inline-block;
    font-weight: bold;
    color: $healthcheck-font-color;
  }
  span {
    padding-right: 10px;
  }
}

</style>
